/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_DescriptionInputs */

const en_homepage_features_description = /** @type {(inputs: Homepage_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turn any academic material into a wonderful listening experience. Upload PDFs, word docs, or scan pages. Listen with passionate A.I. narrators. Turn up the speed, understand difficult material with ease.`)
};

const es_homepage_features_description = /** @type {(inputs: Homepage_Features_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte cualquier material académico en una experiencia auditiva increíble. Sube PDFs, documentos de Word o escanea páginas. Escucha con narradores de I.A. apasionados. Aumenta la velocidad y comprende material difícil con facilidad.`)
};

/**
* | output |
* | --- |
* | "Turn any academic material into a wonderful listening experience. Upload PDFs, word docs, or scan pages. Listen with passionate A.I. narrators. Turn up the s..." |
*
* @param {Homepage_Features_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_description = /** @type {((inputs?: Homepage_Features_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_description(inputs)
	return en_homepage_features_description(inputs)
});